import { types } from 'mobx-state-tree';

const User = types.model('User', {
  username: types.string,
  userimage: types.maybeNull(types.string),
});

export default User;
